module.exports = __webpack_public_path__ + "img/图片.fde1d39e.svg";